import { ActionTree, MutationTree, GetterTree } from 'vuex'
import { COMPARE } from '~/assets/config/api-path'
import { IStateIndex } from '~/store/index'
import { ICompareItem } from '~/assets/interfaces/compare'
import { IProductToCompare } from '~/assets/interfaces/products'
import { filterUrl } from '~/assets/filters/url'
import { analyticsReachGoal } from '~/assets/functions/analytics'
import { runIdle } from '~/assets/functions/runIdle'

interface IState {
  items: ICompareItem[]
}

export const state = (): IState => ({
  items: [],
})

export const mutations: MutationTree<IState> = {
  setItems(state: IState, val: ICompareItem[]) {
    state.items = val
  },
}

export const getters: GetterTree<IState, IStateIndex> = {
  itemsQuantity(state: IState): number {
    return state.items.length
  },
}

export const actions: ActionTree<IState, IStateIndex> = {
  async getItems({ commit }) {
    const response = await this.$axios.$get(filterUrl(COMPARE))
    runIdle(() => {
      commit('setItems', response.items || [])
    })
  },
  async toCompare({ dispatch }, payload: IProductToCompare): Promise<void> {
    await this.$axios.$post(filterUrl(COMPARE), {
      id: payload.id,
    })
    analyticsReachGoal('goal_product_toCompare')
    await dispatch('getItems')
  },
}
